/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {ApiConfig} from "../../api";
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class LivePreviewResource {
  private uri = ApiConfig.obtain().getVersionedUri('livepreview/create');
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  create(viewUrl: string, networkId: string, teamId: string, layoutId: string, layoutParams, width, height) {
    return this.send({
      method: 'POST',
      url: this.uri,
      params: {context: networkId},
      body: {
        networkId: networkId,
        layoutId: layoutId,
        teamId: teamId,
        layoutParameters: layoutParams,
        viewUrl: viewUrl,
        width: width,
        height: height
      }
    });
  }
}
